import React, { Component } from 'react';
import { connect } from 'react-redux';

import questionActions from '../../actions/questions';
import ResponsesManager from '../questions/responsesManager'
import { FocusPointsInputAndConceptSelectorForm, } from '../../../Shared/index';

class EditFocusPointsContainer extends Component {
  getFocusPoint() {
    const { match } = this.props;
    const { params } = match;
    const { focusPointID, questionID } = params;
    const focusPoint = this.props.questions.data[questionID].focusPoints[focusPointID]
    return Object.assign(focusPoint, { id: focusPointID, });
  }

  submitForm = (data, focusPointID) => {
    const { dispatch, match } = this.props;
    const { params } = match;
    const { questionID } = params;
    delete data.conceptResults.null;
    dispatch(questionActions.submitEditedFocusPoint(questionID, data, focusPointID));
    setTimeout(() => {window.history.back()}, 2000);
  };

  render() {
    const { children, match, questions } = this.props;
    const { params } = match;;
    const { questionID } = params;
    return (
      <div>
        <FocusPointsInputAndConceptSelectorForm
          item={this.getFocusPoint()}
          itemLabel="Focus Point"
          onSubmit={this.submitForm}
          questionID={questionID}
          questions={questions}
          ResponsesManager={ResponsesManager}
          states={true}
        />
        {children}
      </div>
    );
  }
}

function select(props) {
  return {
    questions: props.questions
  }
}

export default connect(select)(EditFocusPointsContainer);
